import axios from 'axios';

const baseURL = (process.env.NODE_ENV === 'production') ? process.env.VUE_APP_API_URL : '/api/';

const headers = {
  Authorization: 'Bearer $2y$10$d6GYnC0BEdn6Vx40mtaLJOb1cwh8NDP.i.33/HpBCFll0yJ2fyHBO',
  // Authorization: `Bearer ${process.env.VUE_APP_API_KEY}`,
};

export default () => axios.create({ baseURL, headers });
